// extracted by mini-css-extract-plugin
module.exports = {"bubble":"lC6oK","content":"_2iDF_","triangleWrapper":"_3PV9p","triangle":"_2Hgt7"};